/**
 * Team-onboarded (BOOKMYYOGATTC) schools: show the verification-documents banner
 * until the owner has submitted at least one document for review.
 */
export type SchoolVerificationReminderInput = {
  createdBySource?: string
  verificationStatus?: string
  verificationDocuments?: unknown[] | null | undefined
}

export function shouldShowBookmyyogattcVerificationDocumentsBanner(
  school: SchoolVerificationReminderInput | null | undefined
): boolean {
  if (!school || school.createdBySource !== 'BOOKMYYOGATTC') return false
  if (school.verificationStatus === 'VERIFIED') return false
  const docs = school.verificationDocuments
  const hasSubmittedDocs = Array.isArray(docs) && docs.length > 0
  if (hasSubmittedDocs) return false
  return true
}
